import { documentationSlice } from "./documentationSlice";
import * as actions from "./documentationActions";
import * as selectors from "./documentationSelectors";

export { actions };
export { selectors };

export default documentationSlice.reducer;
